<template>
  <div>
    <div style="max-height: 240px; overflow: auto;">
        <div class="font12px">工单：</div>
        <div v-for="item in selectList" :key="item.order_id" class="pl20">
            {{ item.order_name }}(ID:{{ item.order_id }})
            <span class="cur-delivery">当前落点：{{ item.delivery || '-' }}</span>
        </div>
    </div>
    <!-- 需求方 2026-09-14：不限过去日期/工作日/范围，只做记录；用一句说明代替限制 -->
    <el-alert type="info" :closable="false" show-icon class="mt10"
        title="此处只记录调整结果，不校验日期：可选过去、周末或任意远期日期。请如实填写原因，便于日后追溯。" />
    <el-form ref="formRef" :model="formData" :rules="rules" label-width="100px" class="mt20" @submit.native.prevent>
        <el-form-item label="落点时间：" prop="delivery">
            <el-date-picker v-model="formData.delivery" type="date" value-format="yyyy-MM-dd"
                placeholder="请选择落点时间" style="width: 260px" />
        </el-form-item>
        <el-form-item label="修改原因：" prop="reason">
            <el-input v-model="formData.reason" type="textarea" :rows="3" maxlength="50" show-word-limit
                placeholder="请填写修改原因（50字以内）" style="width: 400px" />
        </el-form-item>
    </el-form>
    <div class="tac">
        <el-button :disabled="submitLoading" @click="$emit('close')">取消</el-button>
        <el-button type="primary" :loading="submitLoading" @click="handleSubmit">确认</el-button>
    </div>
  </div>
</template>

<script>
import API from "@/api/workOrder/material.js"
export default {
    props: {
        cbs: Object,
        selectList: { type: Array, default: () => [] },
    },
    data() {
        // 单选时预填当前落点，方便只改原因/微调日期
        const delivery = this.selectList.length === 1 ? (this.selectList[0].delivery || '') : '';
        return {
            formData: { delivery, reason: '' },
            rules: {
                delivery: [{ required: true, message: '请选择落点时间', trigger: 'change' }],
                reason: [
                    { required: true, message: '请填写修改原因', trigger: 'blur' },
                    { max: 50, message: '修改原因不能超过50个字', trigger: 'blur' },
                ],
            },
            submitLoading: false,
        }
    },
    methods: {
        async handleSubmit() {
            await this.$refs.formRef.validate();
            try {
                this.submitLoading = true
                const { info } = await API.batchUpdateDeliveryApi({
                    order_ids: this.selectList.map(item => item.order_id),
                    delivery: this.formData.delivery,
                    reason: this.formData.reason.trim(),
                })
                this.$message.success(info || '修改成功')
                this.cbs.onSubmit()
            } catch (error) {
                this.$message.error(error.info || '修改失败')
            } finally {
                this.submitLoading = false
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.cur-delivery { margin-left: 8px; font-size: 12px; color: #909399; }
</style>
